import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { apmCaptureError } from '../../apm'
import {
  type TENANT,
  type TenantLanguage,
  tenantToLocaleRegionMap,
} from '../../tenant'

export const crossSellAccessorGetLocalizedProductName = ({
  language,
  product,
  tenant,
}: {
  language: TenantLanguage
  product: CrossSellProduct
  tenant: TENANT
}): string => {
  const productName =
    product.name ??
    // @ts-expect-error -- contract does not reflect that one of the name's fields is required
    (product[`name_${language}_${tenantToLocaleRegionMap[tenant]}`] as
      | string
      | undefined)

  if (!productName) {
    apmCaptureError(
      new Error(
        `CROSS_SELL: product name not found for "${product.id}" for ${tenant} ${language}`,
      ),
    )

    return ''
  }

  return productName
}
